
import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

const SignupSuccessMessage = () => {
  return (
    <div className="max-w-md w-full bg-white rounded-2xl shadow-soft p-8 animate-fade-in border-2 border-green-100">
      <div className="text-center">
        {/* Success Icon */}
        <div className="mx-auto w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-6">
          <CheckCircle className="h-12 w-12 text-green-600" />
        </div>
        
        {/* Success Title */}
        <h1 className="text-2xl font-bold text-brand-blue mb-4">
          Welcome to CareerGuide Kerala!
        </h1>
        
        {/* Success Message */}
        <p className="text-gray-700 text-lg leading-relaxed mb-6">
          You are successfully signed up to CareerGuide Kerala. Now you can login to our portal & get benefit of endless career support system.
        </p>
        
        {/* Login Button */}
        <Link to="/login">
          <Button className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2">
            Login to Your Account
            <ArrowRight className="h-5 w-5" />
          </Button>
        </Link>
        
        {/* Additional Info */}
        <p className="text-sm text-gray-500 mt-4">
          Start your career journey today!
        </p>
      </div>
    </div>
  );
};

export default SignupSuccessMessage;
